import React from "react";

function Menu({ user, onSelect, menuOpen }) {
  return (
    <aside className={`sidebar ${menuOpen ? "open" : ""}`}>
      <ul>
        <li onClick={() => onSelect("board")}>신청서 접수 목록</li>
        {sessionStorage.getItem("grantFg") === "0" && (
          <>
            <li onClick={() => onSelect("manager")}>관리자 계정 관리</li>
            <li onClick={() => onSelect("user")}>사용자 계정 관리</li>
          </>
        )}
        {sessionStorage.getItem("grantFg") === "1" && (
          <>
            <li onClick={() => onSelect("user")}>사용자 계정 관리</li>
          </>
        )}
      </ul>
    </aside>
  );
}

export default Menu;